import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { getData } from "../../../../newApis/dotNetApiMethods";
import { ICustomerSubtypeDocument } from "../../../../interfaces/businessProfile";

export interface IDocumentsByCustomerSubTypeResponse {
  data: ICustomerSubtypeDocument;
}

export const getDocumentsByCustomerSubType = async (
  customerSubType: string,
): Promise<IDocumentsByCustomerSubTypeResponse> => {
  const { data } = await getData(
    `${ajaxEndpoints.DB_CUSTOMER_SUBTYPE_DOCUMENTS}?customerSubType=${customerSubType}`,
  );
  return data;
};

const useDocumentsByCustomerSubType = (customerSubType: string) => {
  return useQuery<IDocumentsByCustomerSubTypeResponse>(
    ["documentsByCustomerSubType", customerSubType],
    () => getDocumentsByCustomerSubType(customerSubType),
    {
      enabled: !!customerSubType,
    },
  );
};

export default useDocumentsByCustomerSubType;
